// removed by extract-text-webpack-plugin
module.exports = {"reviewStars":"style_reviewStars--3SV_Sdar","reviewStar":"style_reviewStar--37JymosV","incompleteStar":"style_incompleteStar--2k3iEHWQ","reviewStarNotApplicable":"style_reviewStarNotApplicable--1FEOGfw6"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/star-rating/src/styles/style.scss
// module id = 1715
// module chunks = 0